module.exports = __webpack_public_path__ + "img/icon_32x32@2x.576b5f62.png";